export const WHATSAPP_URL = 'https://wa.me/966920005929';
export const PHONE_TEL_URL = 'tel:920005929';
export const SALES_EMAIL = 'sales@aait.sa';
